'use client'

import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { X, Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { ToastError } from "@/lib/sonnerUtils";

export function CategoryInput({ categories = [], onChange, setCategories }: { 
  categories?: string[], 
  onChange: (cats: string[]) => void,
  setCategories: Dispatch<SetStateAction<string[]>> 
}) {
  // const [categories, setCategories] = useState<string[]>(initialCategories);
  const [inputValue, setInputValue] = useState("");

  const addCategory = () => {
    if (inputValue && !categories.includes(inputValue)) {
      const newCats = [...categories, inputValue.trim()];
      setCategories(newCats);
      onChange(newCats);
      setInputValue("");
    }
  };

  const removeCategory = (name: string) => {
    const newCats = categories.filter((c) => c !== name);
    setCategories(newCats);
    onChange(newCats);
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2 p-2 border rounded-md bg-background">
        {Array.isArray(categories) && categories?.map((cat) => (
          <Badge key={cat} variant="secondary" className="px-3 py-1 flex items-center gap-1">
            {cat}
            <button onClick={() => removeCategory(cat)} className="ml-1 hover:text-destructive">
              <X size={14} />
            </button>
          </Badge>
        ))}
        <input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addCategory())}
          placeholder="Add category..."
          className="flex-1 bg-transparent outline-none text-sm min-w-[120px]"
        />
      </div>
      <p className="text-xs text-muted-foreground">Press Enter to add a category</p>
    </div>
  );
}